// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2mrRm","notes":"Notes_notes__1-DaI","note":"Notes_note__1PKTu","markdown":"Notes_markdown__B0iVu"};